import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import Login from './components/Login';
import Register from './components/Register';
import PasswordRecovery from './components/PasswordRecovery';
import Dashboard from './components/Dashboard';
import UserList from './components/dashboard/UserList';
import CallPage from './components/dashboard/CallPage/CallPage';
import NewsList from './components/dashboard/NewsList';
import AddNews from './components/dashboard/AddNews';
import EditNews from './components/dashboard/EditNews';
import EditUserRole from './components/dashboard/EditUserRole';
import CourseList from './components/dashboard/CourseList';
import CourseDetails from './components/dashboard/CourseDetails';
import CreateCourse from './components/dashboard/CreateCourse';
import CourseModules from './components/dashboard/CourseModules';
import CreateModule from './components/dashboard/CreateModule';
import CreateTest from './components/dashboard/CreateTest';
import MyCourses from './components/dashboard/MyCourses';
import TestPage from './components/dashboard/TestPage';
import TestResults from './components/dashboard/TestResults';
import UploadJournal from './components/dashboard/UploadJournal';
import ViewJournals from './components/dashboard/ViewJournals';
import Profile from './components/dashboard/Profile';

const App = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/recover-password" element={<PasswordRecovery />} />

    <Route element={<PrivateRoute />}>        
      <Route
        path="/dashboard/*"
        element={<Dashboard />}
      >
        <Route path="users" element={<UserList />} />
        <Route path="call/:otherUserId" element={<CallPage />} />
        <Route path="edit-roles" element={<EditUserRole />} />
        <Route path="news" element={<NewsList />} />
        <Route path="add-news" element={<AddNews />} />
        <Route path="news/edit/:id" element={<EditNews />} />
        <Route path="courses" element={<CourseList />} />
        <Route path="courses/:id" element={<CourseDetails />} />
        <Route path="create-course" element={<CreateCourse />} />
        <Route path="courses/:id/modules" element={<CourseModules />} />
        <Route path="courses/:id/create-module" element={<CreateModule />} />
        <Route path="courses/:id/modules/:moduleId/create-test" element={<CreateTest />} />
        <Route path="my-courses/:userId" element={<MyCourses />} />
        <Route path="profile" element={<Profile />} />
        <Route path="test/:id" element={<TestPage />} />
        <Route path="test-results" element={<TestResults />} />
        <Route path="upload-journal" element={<UploadJournal />} />
        <Route path="view-journals" element={<ViewJournals />} />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default App;